import React, { useState } from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'
import LazyImage from '../LazyImage'

import { getSomeStories } from '../../data/stories'

export default function EventsCard (props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true })

  const divStyle = src => ({
    backgroundImage: 'url(' + src + ')'
  })

  const renderStories = items =>
    items.map(data => {
      if (props.events) {
        if (data.event_image.url) {
          var bgImage = data.event_image.url
        } else {
          var bgImage = '/public-next/images/quell-placeholder.png'
        }
      } else {
        if (data._embedded['wp:featuredmedia']) {
          var bgImage = data._embedded['wp:featuredmedia'][0].source_url
        } else {
          var bgImage = '/public-next/images/quell-placeholder.png'
        }
      }

      return props.events ? (
        data.archive == 'visible' ? (
          <div
            ref={slideUpRef}
            key={data.event_date}
            className={`animation col-12 col-lg-6 link-column ${
              isInView ? 'slide-up' : ''
            }`}
          >
            <LazyImage background imageClass='link-column__image' src={bgImage}>
              <div className='image__caption col-10'>
                <h2 className='image-caption' id={`article-${data.id}`}>
                  <span dangerouslySetInnerHTML={{ __html: data.event_date }} />
                  &nbsp;|&nbsp;
                  <span
                    dangerouslySetInnerHTML={{ __html: data.event_location }}
                  />
                </h2>
              </div>
            </LazyImage>

            <div className='link-column__text'>
              <h3 className='event-name'>{data.event_name}</h3>

              <div
                className='event-description'
                dangerouslySetInnerHTML={{ __html: data.event_body }}
              />

              <div>
                {data.event_link ? (
                  <a
                    href={data.event_link.url}
                    target={data.event_link.target}
                    rel={`${
                      data.event_link.target == '_blank' ? 'noopener' : ''
                    }`}
                    className='link'
                    aria-labelledby={`article${data.id}`}
                  >
                    {data.event_link.title}

                    {data.event_link.target == '_blank' ? (
                      <React.Fragment>
                        <span className='sr-only'>
                          {' '}
                          external link opens in new tab{' '}
                        </span>
                        <span className='fas fa-external-link-alt'> </span>
                      </React.Fragment>
                    ) : (
                      ''
                    )}
                  </a>
                ) : (
                  ''
                )}

                {data.event_donate_link ? (
                  <a
                    href={data.event_donate_link.url}
                    target={data.event_donate_link.target}
                    rel={`${
                      data.event_donate_link.target == '_blank'
                        ? 'noopener'
                        : ''
                    }`}
                    className='link'
                    aria-labelledby={`article${data.id}`}
                  >
                    {data.event_donate_link.title}

                    {data.event_donate_link.target == '_blank' ? (
                      <React.Fragment>
                        <span className='sr-only'>
                          {' '}
                          external link opens in new tab{' '}
                        </span>
                        <span className='fas fa-external-link-alt'> </span>
                      </React.Fragment>
                    ) : (
                      ''
                    )}
                  </a>
                ) : (
                  //if no data.event_donate_link, don't display the button
                  ''
                )}
              </div>
            </div>
          </div>
        ) : (
          //if data.archive is not 'visible', then display nothing
          ''
        )
      ) : (
        //if no props.events then display this
        ''
      )
    })

  return (
    <React.Fragment>
      <span id='skip'></span>
      <div ref={slideUpRef} className='container-fluid link-columns mt-200'>
        {props.events ? (
          <div className='row'>{renderStories(props.content)}</div>
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
}
